<template>
  <div class="qualification-list">
    <div class="btn-list">
      <span v-has="buttonAuth[0]" class="btn" @click="search">
        <i class="el-icon-search icon"></i>查询
      </span>
       <span v-has="buttonAuth[1]" class="btn" @click="add">
        <i class="el-icon-circle-plus-outline icon"></i>新增
      </span>
       <span v-has="buttonAuth[2]" class="btn" @click="del">
        <i class="el-icon-delete icon"></i>删除
      </span>
    </div>
    <div class="qualification-table">
      <vbt-table
          ref="vbt"
          size="mini"
          isBigData
          isTreeTable
          highlight-hover-row
          height="600"
          max-height="600"
          :data="tableData"
          style="margin-bottom: 20px;width: 100%;"
          row-key="myID"
          border
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @selection-change="selectionChange"
      >
        <vbt-table-column type="selection" width="40"></vbt-table-column>
        <vbt-table-column prop="title" label="资质标题" width="180"></vbt-table-column>
        <vbt-table-column prop="qualificationType" label="资质类型" width="120"></vbt-table-column>
        <vbt-table-column prop="qualificationName" label="资质文件" width="300"></vbt-table-column>
        <vbt-table-column prop="defautQualificationFlagName" label="是否默认资质" width="120"></vbt-table-column>
        <vbt-table-column prop="updateTime" label="更新时间" width="180"></vbt-table-column>
        <vbt-table-column label="附件" width="180">
            <template slot-scope="scope">
                <span v-has="buttonAuth[3]" class="upload" v-if="scope.row.qualificationName && !(scope.row.qualificationType.indexOf('司机资质')> -1 || scope.row.qualificationType.indexOf('车辆资质')> -1)"
                @click="uploadDialog(scope.row)">上传附件</span>
                <span
                    class="upload upload-online-write bigData-btn-q-online"
                    v-if="qualificationLineTypes.includes(scope.row.qualificationName)"
                    @click="handleWrite(scope.row,scope.row.qualificationName)"
                    >线上填写</span>
            </template>
        </vbt-table-column>
        <vbt-table-column prop="fileName" label="预览" width="180">
            <template slot-scope="scope">
                <span v-has="buttonAuth[4]" class="upload" v-if="scope.row.fileUrl" @click="preview(scope.row)" v-text="scope.row.fileName"></span>
            </template>
        </vbt-table-column>
        <vbt-table-column prop="fileUrl" label="下载" width="180">
            <template slot-scope="scope">
                <!-- <el-button v-has="buttonAuth[5]" v-if="scope.row.fileUrl" type="text" @click.native="handleDownload(scope.row)">下载附件</el-button> -->
                <a v-has="buttonAuth[5]" v-if="scope.row.fileUrl" class="qualification-download-btn bigData-btn-qualification-download" type="text" :href="scope.row.fileUrl" target="_blank">下载附件</a>
            </template>
        </vbt-table-column>
        <vbt-table-column prop="certificateEndDate" label="终止日期" width="220">
            <template slot-scope="scope">
                <div>
                    <span>{{scope.row.certificateEndDate}}</span>
                    <span class="early-warning-date" v-if="scope.row.earlyWarning === 1">已过期</span>
                </div>
            </template>
        </vbt-table-column>
        <vbt-table-column prop="certificateNo" label="证件号" width="180"></vbt-table-column>
      </vbt-table>
    </div>
    <TransLegalDialog ref="tldRef" @submit="search"/>
    <TransPersonDialog ref="tpdRef" @submit="search"/>
    <DeliveryLegalDialog ref="dldRef" @submit="search"/>
    <DeliveryPersonDialog ref="dpdRef" @submit="search"/>
    <preview
        v-if='attachmentShow'
        :attachmentList="attachmentList"
        :attachmentShow.sync='attachmentShow'
        :rowData='rowData'>
    </preview>
    <dialog-box v-if="cerDialogVisible" :supplierCode="supplierCode" :cerDialogVisible.sync="cerDialogVisible" :showtype="showtype" :form="form" :flag="flag"
            @search="search" @handleClose="handleClose" @cerCallback="cerCallback" @callback="callback" @previewBtn="previewBtn"></dialog-box>
    <el-dialog v-drag width="500px" :visible.sync="dialogVisible" :before-close="handleClose">
        <div slot="title">{{DialogTitle}}</div>
            <el-form class='form-item' ref="form" :model="form" :rules="rules" :label-width="formLabelWidth">
                <el-form-item label="资质名称" prop="qualificationName" v-if="addType==='add'">
                    <el-input v-model="form.qualificationName" placeholder="请输入资质名称" class="input-class"></el-input>
                </el-form-item>
                <el-form-item :label="cerNoLabel" prop="certificateNo" class="dialog-item" v-if="!anntoNoRelated && !isSupScorePrefix && !isInvoiceCtfPrefix && !isRiverSeaRail && !isOverseaNoDetail">
                    <el-input v-model="form.certificateNo" placeholder="请输入证件号" class="input-class"></el-input>
                </el-form-item>
                <el-form-item label="开始日期" prop="certificateBeginDate" v-if="!anntoNoRelated && !isSupScorePrefix && !isInvoiceCtfPrefix && !isRiverSeaRail && !isOverseaNoDetail">
                    <el-date-picker v-model="form.certificateBeginDate" value-format="yyyy-MM-dd" type="date" placeholder="选择开始日期" class="input-class"></el-date-picker>
                </el-form-item>
                <el-form-item label="终止日期" prop="certificateEndDate" v-if="!anntoNoRelated && !isSupScorePrefix && !isInvoiceCtfPrefix && !isRiverSeaRail && !isOverseaNoDetail">
                    <el-date-picker v-model="form.certificateEndDate" value-format="yyyy-MM-dd" type="date" placeholder="选择终止日期" class="input-class"></el-date-picker>
                </el-form-item>
                 <el-form-item label="上传附件" prop="fileName" class="upload-item">
                    <el-input v-model="form.fileName" placeholder="点击上传附件" class="input-class" readonly></el-input>
                    <upload :uploadDisplayType="uploadDisplayType" :accept="uploadAccept" :flag="flag" class="upload-item-icon" :sizeLimit="sizeLimit" @uploadSuccess="callback"> </upload>
                    <span @click="previewBtn('normal')" class="preview_btn">预览</span>
                    <span v-if="isInvoiceCtfPrefix" @click="previewBtn('INVOICE_CTF')" class="preview_btn">样式参考</span>
                </el-form-item>
            </el-form>
            <div v-if="anntoNoRelated || isSupScorePrefix || isRiverSeaScore" :style="{ marginLeft: formLabelWidth }">
                <div class="ql-upload-tip">上传文件不超过{{ sizeLimit }}MB, 文件支持图片,word,.ppt,.pptx,.pdf,.Excel</div>
                <div><el-button type="primary" :loading="tempLoading" @click="handleTemp(form.qualificationName)">下载模板</el-button></div>
                <!-- <div><el-button type="primary" :loading="tempLoading" @click="handleTemp(form1.qualificationName)">下载模板</el-button></div> -->
            </div>
            <div v-if="isOverseaNoDetail" :style="{ marginLeft: formLabelWidth }">
                <div class="ql-upload-tip">上传文件不超过{{ sizeLimit }}MB, 文件支持图片,word,.ppt,.pptx,.pdf,.Excel</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import { vbtTable, vbtTableColumn } from 'vbt-table';
import dialogBox from './dialogBox.vue';
import upload from '../../../../../components/upload/Index';
import preview from '../../../../../components/viewAttachment.vue';
import TransLegalDialog from '../../../manage/keyData/tabs/qualification/TransLegalDialog.vue';
import TransPersonDialog from '../../../manage/keyData/tabs/qualification/TransPersonDialog.vue';
import DeliveryLegalDialog from '../../../manage/keyData/tabs/qualification/DeliveryLegalDialog.vue';
import DeliveryPersonDialog from '../../../manage/keyData/tabs/qualification/DeliveryPersonDialog.vue';
import { qualificationInfo, uploadFiles, addQualification, delQualification, getLoginUser, downloadRegisterGuide } from '../../../../../api/qualification.js';
import { OSS_FILE_MAX_SIZE } from '../../../../../constant/constant.js';

const DICNAMEONLINEA = '供应商评分表-运输-车队供应商&物流供应商';
const DICNAMEONLINEB = '供应商评分表-运输-长合车类';
const DICNAMEONLINEC = '供应商评分表-配送-法人供应商';
const DICNAMEONLINED = '供应商评分表-配送-长合车类';
const BASIC_QUALIFICATION = '基本资质';
const DRIVER_QUALIFICATION = '司机资质';
const VEHICLE_QUALIFICATION = '车辆资质';
const WAREHOUSE_QUALIFICATION = '仓库资质';
const BUTTON_AUTH = ['08000115', '08000116', '08000117', '08000118', '08000119', '08000120'];
const THIRTY_SIX = 36;
const TEN_X = 0x10;
const EIGHT_X = 0x8;
const THREE_X = 0x3;
const TWO_HUNDRED = 200;
const ANNTO_NO_RELATED = '与安得无亲属关系证明';
const IS_DEFAULT_QLF = '0'; // 是否为默认资质
const SUP_SCORE = '供应商评分表'
const INVOICE_CTF = '开票底联凭证'
const RIVER_SEA_SCORES = ['评审表-水运', '评审表-铁运']
const SEA_RAIL_QLTS = ['历史海运开票底联', '铁路经营许可证', '历史铁运开票底联']
const OVERSEA_WITH_DETAIL = ['有船承运人资质（有船承运或船舶登记）', '国际货运代理企业备案表或快递业务经营许可证书', '国际货运代理企业备案或道路经营许可证', '报关资质']
const OVERSEA_NUM_LABEL = ['有船承运人资质编码', '证件编号', '证件编号', '报关资质证件编号']
const OVERSEA_NO_DETAIL = ['国际货运代理企业备案表或无船承运人资质', '国际货运代理企业备案表', '国际货运代理企业备案表（与铁路公司合作合同或授权证明）', '国际货运代理企业备案表', '收款账号开户信息', '订舱代理资质材料']

// 资质名称对应模板
const QUALIFY_TEMP_LIST = [
    { name: '与安得无亲属关系证明', fileName: 'proofOfNoRelativity.xlsx' },
    { name: '供应商评分表（运输）', fileName: 'transportScore.xlsx' },
    { name: '供应商评分表（配送）', fileName: 'dispatchingScore.xlsx' },
    { name: '供应商评分表（装卸）', fileName: 'loadUnloadScore.xlsx' },
    { name: '供应商评分表（仓管）', fileName: 'warehouseManagementScore.xlsx' },
    { name: DICNAMEONLINEA, fileName: 'supplierScoreLegalPersonTransport.xlsx' },
    { name: DICNAMEONLINEB, fileName: 'supplierScoreNaturalPersonTransport.xlsx' },
    { name: DICNAMEONLINEC, fileName: 'supplierScoreLegalPersonDelivery.xlsx' },
    { name: DICNAMEONLINED, fileName: 'supplierScoreNaturalPersonDelivery.xlsx' },
    { name: '供应商评分表', fileName: 'scoreModel.xlsx' },
    { name: '评审表-水运', fileName: 'waterTransport.xlsx' },
    { name: '评审表-铁运', fileName: 'railwayTransport.xlsx' },
]
const QUALIFY_ONLINE_LIST =[DICNAMEONLINEA,DICNAMEONLINEB,DICNAMEONLINEC,DICNAMEONLINED]

export default {
    name: 'Qualification',
    components: { upload, preview, dialogBox, vbtTable, vbtTableColumn, TransLegalDialog, TransPersonDialog, DeliveryLegalDialog, DeliveryPersonDialog },
    data() {
        return {
            uploadAccept: 'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf',
            sizeLimit: OSS_FILE_MAX_SIZE,
            flag: {},
            defautQualificationFlag: null, // 点击附件上传时暂存的是否默认资质
            form: {
                id: '',
                supplierCode: '',
                qualificationName: '',
                certificateBeginDate: '',
                certificateEndDate: '',
                fileName: '',
                fileUrl: '',
                fileId: '',
                qualificationTypeCode: '',
                qualificationType: '',
                certificateNo: ''
            },
            dialogVisible: false,
            uploadDisplayType: 'icon',
            text: '上传附件',
            dialogText: '点击上传',
            attachmentShow: false,
            rowData: {},
            delRowData: [],
            addRowData: [],
            allSelect: [],
            tableData: [],
            supplierCode: '',
            addType: 'add', // 判断当前操作是上传附件还是新增
            DialogTitle: '新增', // 上传附件或新增弹窗标题
            buttonAuth: BUTTON_AUTH,
            attachmentList: [],
            allAttachmentList: [],
            cerDialogVisible: false,
            showtype: '0', // 弹窗类型控制 1-身份证 2-营业执照 3-道路经营许可证 4-快递业务经营许可证
            cerbehiRowData: {},
            cerRowData: {},
            tempLoading: false, // 与安得无亲属关系证明 下载模板加载
            qualificationLineTypes: QUALIFY_ONLINE_LIST
        };
    },
    computed: {
        formLabelWidth() {
            return this.isInvoiceCtfPrefix ? '85px' : '145px'
        },
        cerNoLabel() {
            let title = '证件号'
            const idx = OVERSEA_WITH_DETAIL.findIndex(item => item === this.form.qualificationName)
            if (this.defautQualificationFlag === IS_DEFAULT_QLF && idx >= 0) {
                title = OVERSEA_NUM_LABEL[idx]
            }
            return title
        },
        rules(){
            // 判断是否为海外业务的资质
            const isOverseaQlfs = this.defautQualificationFlag === IS_DEFAULT_QLF && [...OVERSEA_WITH_DETAIL, ...OVERSEA_NO_DETAIL].includes(this.form.qualificationName)
            return {
                certificateNo: [{ required: isOverseaQlfs, message: `请输入${this.cerNoLabel}`, trigger: ['change'] }],
                qualificationName: [
                    { required: true, message: '请输入资质名称', trigger: ['blur', 'change'] }
                ],
                certificateBeginDate: [{ required: isOverseaQlfs, message: '请选择开始日期', trigger: ['change'] }],
                certificateEndDate: [
                    { required: true, message: '请选择终止日期', trigger: ['blur', 'change'] }
                ],
                fileName: [
                    { required: true, message: '请上传附件' }
                ]
            }
        },
        anntoNoRelated() {
            // 默认资质，且资质文件为 与安得无亲属关系证明
            return this.defautQualificationFlag === IS_DEFAULT_QLF && this.form.qualificationName === ANNTO_NO_RELATED;
        },
        // 默认资质，且为'供应商评分表'为前缀的相关资质
        isSupScorePrefix() {
            return this.defautQualificationFlag === IS_DEFAULT_QLF &&
                this.form.qualificationName && this.form.qualificationName.indexOf(SUP_SCORE) === 0;
        },
        // 默认资质，且为'开票底联凭证'为前缀的相关资质
        isInvoiceCtfPrefix() {
            return this.defautQualificationFlag === IS_DEFAULT_QLF &&
                this.form.qualificationName && this.form.qualificationName.indexOf(INVOICE_CTF) === 0;
        },
        // 默认资质，且为['评审表-水运', '评审表-铁运']资质
        isRiverSeaScore() {
            return this.defautQualificationFlag === IS_DEFAULT_QLF &&
                // this.form1.qualificationName && RIVER_SEA_SCORES.includes(this.form1.qualificationName);
                this.form.qualificationName && RIVER_SEA_SCORES.includes(this.form.qualificationName);
        },
        // 默认资质，且为['评审表-水运', '历史海运开票底联', '铁路经营许可证', '评审表-铁运', '历史铁运开票底联']资质
        isRiverSeaRail() {
            return this.defautQualificationFlag === IS_DEFAULT_QLF &&
                // this.form1.qualificationName && RIVER_SEA_SCORES.concat(SEA_RAIL_QLTS).includes(this.form1.qualificationName);
                this.form.qualificationName && RIVER_SEA_SCORES.concat(SEA_RAIL_QLTS).includes(this.form.qualificationName);
        },
        isOverseaNoDetail() {
            return this.defautQualificationFlag === IS_DEFAULT_QLF && OVERSEA_NO_DETAIL.includes(this.form.qualificationName)
        },
    },
    created() {
        getLoginUser().then(res => {
            if (res && +res.code === 0) {
                this.supplierCode = res.data;
                this.search();
            }
        });
    },
    methods: {
        expandRow(list){
            list.forEach((v,i) => {
                if(v.title === '基本资质'){
                    this.$refs['vbt'].toggleRowExpansion(v,true)
                    // this.expandRow(v.children)
                }
            })
            this.$nextTick(() => {
              this.$refs['vbt'].$el.classList.add('el-table--scrollable-y')
            })
        },
        getRowKey(list, parentNode = '') {
            for (let i = 0; i < list.length; i++) {
                const node = list[i];
                if (node) {
                    node.parent = parentNode;
                    let parent = '';
                    if (node.title === BASIC_QUALIFICATION) {
                        parent = BASIC_QUALIFICATION;
                    } else if (node.title === DRIVER_QUALIFICATION) {
                        parent = DRIVER_QUALIFICATION;
                    } else if (node.title === VEHICLE_QUALIFICATION) {
                        parent = VEHICLE_QUALIFICATION;
                    } else if (node.title === WAREHOUSE_QUALIFICATION) {
                        parent = WAREHOUSE_QUALIFICATION;
                    }
                    node.myID = this.getMyId();
                    const children = node.children;
                    if (children && children.length > 0) {
                        this.getRowKey(children, parent);
                    }
                }
            }
        },
        getMyId() {
            const s = [];
            const hexDigits = '0123456789abcdef';
            for (let i = 0; i < THIRTY_SIX; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * TEN_X), 1);
            }
            s[14] = '4';
            s[19] = hexDigits.substr((s[19] & THREE_X) | EIGHT_X, 1);
            s[8] = s[13] = s[18] = s[23] = '-';
            const myID = s.join('');
            return myID;
        },
        save() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (this.addType === 'upload') {
                        uploadFiles(this.getParamsFromUpload()).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('上传成功');
                                this.handleClose();
                                this.search();
                            }
                        });
                    } else if (this.addType === 'add') {
                        addQualification(this.form).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('资质新增成功');
                                this.handleClose();
                                this.search();
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        getParamsFromUpload() {
            const params = JSON.parse(JSON.stringify(this.form))
            if (this.anntoNoRelated || this.isSupScorePrefix || this.isInvoiceCtfPrefix) {
                delete params.certificateNo
                delete params.certificateBeginDate
                delete params.certificateEndDate
            }
            return params
        },
        handleDelRowData(row) {
            const FNode = [];
            const arr = [];
            row.forEach(item => {
                if (item.qualificationName) {
                    FNode.push(item);
                } else {
                    arr.push('FNode');
                }
            });
            FNode.forEach(item => {
                if (item.defautQualificationFlag === '1') {
                    arr.push(item.id);
                } else {
                    arr.push('UnDefault');
                }
            });
            this.delRowData = arr;
        },
        /** 符合添加资质的节点才加入勾选列表中 **/
        handleAddRowData(row) {
            const arr = [];
            row.forEach(item => {
                if (item.title === BASIC_QUALIFICATION ||
                    item.parent === DRIVER_QUALIFICATION ||
                    item.parent === VEHICLE_QUALIFICATION ||
                    item.parent === WAREHOUSE_QUALIFICATION) {
                    arr.push(item);
                }
            });
            this.addRowData = arr;
        },
        cerCallback(data) {
            if (data.ocr === 'idCardFont') { // 身份证人像面
                this.form.certificateNo = data.data.ocrResult.idNumber;
                this.form.uploadIdentityFront = data.data.ossResult.localFileName;
                this.form.uploadIdentityFrontUrl = data.data.ossResult.downUrl;
                this.form.uploadIdentityFrontFileId = data.data.ossResult.id;
                this.cerRowData = {
                    downUrl: data.data.ossResult.downUrl,
                    fileName: data.data.ossResult.localFileName,
                    fileId: data.data.ossResult.id
                };
                this.form = { ...this.form };
                if (!this.form.certificateNo) {
                    this.$message.warning('请正确上传身份证人像面！');
                    return;
                }
            } else {
                this.form.certificateBeginDate = data.data.ocrResult.idCardStartTime;
                this.form.certificateEndDate = data.data.ocrResult.idCardEndTime;
                this.form.uploadIdentityBehind = data.data.ossResult.localFileName;
                this.form.uploadIdentityBehindUrl = data.data.ossResult.downUrl;
                this.form.uploadIdentityBehindFileId = data.data.ossResult.id;
                this.cerbehiRowData = {
                    downUrl: data.data.ossResult.downUrl,
                    fileName: data.data.ossResult.localFileName,
                    fileId: data.data.ossResult.id
                };
                this.form = { ...this.form };
            }
            this.attachmentList = [];
            this.rowData.updateTime = data.data.timestamp;
            this.$message.success('附件上传成功');
        },
        selectionChange(row) {
            this.allSelect = row;
            this.handleDelRowData(row);
            this.handleAddRowData(row);
        },
        handleGetAllAttachmentList(list) {
            for (let i = 0; i < list.length; i++) {
                const node = list[i];
                this.allAttachmentList.push(node.fileUrl);
                if (node.children && node.children.length) {
                    this.handleGetAllAttachmentList(node.children);
                }
            }
        },
        search() {
            qualificationInfo(this.supplierCode).then(res => {
                if (res && +res.code === 0) {
                    this.getRowKey(res.data);
                    this.tableData = res.data;
                    this.handleGetAllAttachmentList(res.data);
                    this.allAttachmentList = this.allAttachmentList.filter((item) => { if (item) return item; });
                    this.$nextTick(_ => {
                        this.expandRow(this.tableData)
                    })
                }
            });
        },
        uploadDialog(data) {
            this.addType = 'upload';
            if (data.qualificationName.indexOf(SUP_SCORE) === 0 || data.qualificationName.indexOf(INVOICE_CTF) === 0) {
                this.DialogTitle = '上传' + data.qualificationName
            } else {
                this.DialogTitle = '上传'
            }
            this.defautQualificationFlag = data.defautQualificationFlag;
            this.form.qualificationType = data.qualificationType;
            this.form.qualificationTypeCode = data.qualificationTypeCode;
            this.form.supplierCode = data.supplierCode;
            this.form.certificateBeginDate = data.certificateBeginDate;
            this.form.qualificationName = data.qualificationName;
            this.form.certificateNo = data.certificateNo;
            this.form.certificateEndDate = data.certificateEndDate;
            this.flag = {
                id: data.id,
                qualificationType: data.qualificationType,
                qualificationTypeCode: data.qualificationTypeCode,
                qualificationName: data.qualificationName
            };
            if (data.qualificationName.indexOf('身份证') > -1 || data.qualificationName.indexOf('身份证') > -1) {
                this.showtype = '1';
                this.cerDialogVisible = true;
            } else if (data.qualificationName.indexOf('营业执照') > -1 || data.qualificationName === '道路经营许可证' || data.qualificationName === '快递业务经营许可证') {
                this.showtype = data.qualificationName.indexOf('营业执照') > -1 ? '2' : data.qualificationName === '道路经营许可证' ? '3' : '4';
                this.cerDialogVisible = true;
            } else {
                this.dialogVisible = true;
            }
        },
        add() {
            if (this.allSelect.length > 1 || !this.allSelect.length) {
                this.$message.warning('请选择一个父级节点新增资质');
                return;
            }
            if (this.addRowData.length < 1) {
                this.$message.warning('请选择有效父节点新增资质');
                return;
            }
            this.addType = 'add';
            this.DialogTitle = '新增';
            this.form.supplierCode = this.supplierCode;
            this.form.qualificationType = this.addRowData[0].qualificationType;
            this.form.qualificationTypeCode = this.addRowData[0].qualificationTypeCode;
            this.dialogVisible = true;
        },
        del() {
            if (this.delRowData.length) {
                if (this.delRowData.indexOf('FNode') !== -1) {
                    this.$message.warning('有父级被选中了');
                } else if (this.delRowData.indexOf('UnDefault') !== -1) {
                    this.$message.warning('有默认资质被选中了');
                } else {
                    this.$confirm('确定要删除选中的资质吗？', '删除提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        delQualification(this.delRowData).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('删除成功');
                                this.search();
                            }
                        });
                    });
                }
            } else {
                this.$message.warning('请选择要删除的资质');
            }
        },
        callback(data) {
            if (data.data.code === '0') {
                this.rowData = data.data.data;
                this.attachmentList = [];
                this.rowData.updateTime = data.data.timestamp;
                this.form.fileName = data.data.data.localFileName;
                this.form.fileUrl = data.data.data.downUrl;
                this.form.fileId = data.data.data.id;
                this.form.id = data.flag.id;
                this.$message.success('附件上传成功');
            } else {
                this.$message.error('上传失败');
            }
        },
        preview(data) {
            this.rowData.downUrl = data.fileUrl;
            this.attachmentList = this.allAttachmentList;
            this.attachmentShow = true;
        },
        previewBtn(flag) {
            this.attachmentList = []
            if (flag === 'normal' && this.form.fileName) {
                this.attachmentShow = true;
                this.rowData.downUrl = this.form.fileUrl;
                return;
            }
            if (flag === 'cer' && this.cerRowData.fileName) {
                this.attachmentShow = true;
                this.rowData = this.cerRowData;
                return;
            }
            if (flag === 'cerbehi' && this.cerbehiRowData.fileName) {
                this.attachmentShow = true;
                this.rowData = this.cerbehiRowData;
                return;
            }
            // 开票底联凭证 样式参考
            if (flag === 'INVOICE_CTF') {
                this.attachmentShow = true;
                this.rowData = { downUrl: require('../../../manage/keyData/tabs/qualification/imgs/kpdlpzYsck.png') }
                return;
            }
            this.$message.warning('请上传附件');
        },
        // 文件下载更改名称
        getBlob(url, cb) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = () => {
                if (xhr.status === TWO_HUNDRED) {
                    cb(xhr.response);
                }
            };
            xhr.send();
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const link = document.createElement('a');
                const body = document.querySelector('body');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.style.display = 'none';
                body.appendChild(link);
                link.click();
                body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }
        },
        // handleDownload(data) {
        //     if (data.fileUrl) {
        //         const suffix = data.fileUrl.substring(data.fileUrl.lastIndexOf('.') + 1);
        //         this.getBlob(data.fileUrl, blob => {
        //             this.saveAs(blob, data.qualificationName + '.' + suffix);
        //         });
        //     }
        // },
        handleClose(type) {
            this.form = {
                id: '',
                supplierCode: this.supplierCode,
                qualificationName: '',
                certificateBeginDate: '',
                certificateEndDate: '',
                fileName: '',
                fileUrl: '',
                qualificationTypeCode: '',
                qualificationType: '',
                certificateNo: ''
            };
            this.cerRowData = {};
            this.cerbehiRowData = {};
            this.cerDialogVisible = false;
            this.dialogVisible = false;
            if (type === 'cert') { return; }
            this.$refs['form'].resetFields();
        },
        handleTemp(qualificationName) {
            const qlfItem = QUALIFY_TEMP_LIST.find(item => item.name === qualificationName)
            if (!qlfItem) {
                return this.$message.warning('查找不到该模板!')
            }
            this.tempLoading = true;
            downloadRegisterGuide({ fileName: qlfItem.fileName }).then(res => {
                if (res) {
                    const blob = new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    this.saveAs(blob, qlfItem.name + '.xlsx');
                    this.$message.success('模板已下载!');
                }
            }).finally(() => { this.tempLoading = false; })
        },
        handleWrite(row, qualificationName) {
            if (qualificationName === DICNAMEONLINEA) {
                this.$refs.tldRef && this.$refs.tldRef.open(row);
            } else if (qualificationName === DICNAMEONLINEB) {
                this.$refs.tpdRef && this.$refs.tpdRef.open(row);
            } else if (qualificationName === DICNAMEONLINEC) {
                this.$refs.dldRef && this.$refs.dldRef.open(row);
            } else if (qualificationName === DICNAMEONLINED) {
                this.$refs.dpdRef && this.$refs.dpdRef.open(row);
            }
        }
    }
};
</script>

<style lang="less">
.qualification-list {
    .btn-list {
        display: flex;
        align-items: center;
        height: 28px;
        background: #FFFBF2;
        border: 1px solid #FFECE3;
        border-radius: 0.5px;

        .btn {
            margin-left: 30px;
            font-size: 14px;
            color: #666;
            cursor: pointer;
        }

        .icon {
            margin-right: 5px;
        }
    }
    .early-warning-date{
        display: inline-block;
        margin-left: 10px;
        font-size: 12px;
        height: 20px;
        width: 50px;
        text-align: center;
        border: 1px solid #FFECE3;
        border-radius: 30%;
        background-color:  rgb(250, 231, 234);
        color: rgb(217, 0, 27);
    }
.upload-online-write{
    margin-left: 10px;
}
    .qualification-table {
        margin-top: 10px;

        .idCard {
            top: 4px;
        }

        .upload {
            color: #00BCBF;
            cursor: pointer;
        }
    }

    .input-class {
        width: 260px;

        .el-input__inner {
            width: 260px;
        }
    }

    .upload-item {
        position: relative;

        .upload-item-icon {
            position: absolute;
            top: 2px;
            width: 265px;
            height: 28px;
            font-size: 16px;
            color: #33c9cc;
        }

        .upload-demo {
            width: 100%;
            height: 28px;
        }
    }

    .el-upload {
        width: 100%;
        height: 28px;
        text-align: right;
    }

    .upload_icon {
        padding-right: 8px;
        width: 100%;
        height: 23px;
        box-sizing: border-box;
    }

    .preview_btn {
        margin-left: 10px;
        text-decoration: underline;
        color: #33c9cc;
        cursor: pointer;
    }

    .qualification-download-btn {
        color: #00BCBF;
    }

    .ql-upload-tip {
        margin-top: 12px;
        margin-bottom: 10px;
        width: 260px;
    }

    .el-form-item {
        margin-bottom: 8px;
    }

    .el-form-item__label, .el-form-item__content {
        line-height: 40px;
    }

    .el-form-item__error {
        padding-top: 0;
    }
}
</style>
